import { helperFunctions } from "../helper";
import {  CountryCodes, OdQueryParam } from "../enums";
import { ICounty, ICountyAllResponse } from "../models/ICounty.model";

import { IState, IStateAllResponse } from "../models/IState.model";
import NetworkService from "../network/networkService";
import { Observable } from "rxjs";
import { URLConfig } from "../network/urlStore";

export const getAllCounty = (
  queryParams?: Array<{
    key:OdQueryParam;
    value: string[];
  }>
): Observable<ICountyAllResponse> => {
  let url = URLConfig.getAllCountyMasterDataURL();
  for (let param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }

  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (locationResponse: unknown) => {
        if (locationResponse) {
          const locationsResponse = locationResponse as ICountyAllResponse;
          subscriber.next(locationsResponse);
        }
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while fetching Locations master data", error);
      }
    );
  });
};

export const getCountyNextPage = (
  nextPageURI: string
): Observable<ICountyAllResponse> => {
  let url = URLConfig.getBrandsNextPageURl(nextPageURI);

  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (locationResponse: unknown) => {
        if (locationResponse) {
          const locationsResponse = locationResponse as ICountyAllResponse;
          subscriber.next(locationsResponse);
        }
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while fetching Locations master data", error);
      }
    );
  });
};

export const getAllState = (
  queryParams?: Array<{
    key: OdQueryParam;
    value: string[];
  }>
): Observable<IStateAllResponse> => {
  let url = URLConfig.getAllStateMasterDataURL();

  for (let param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (locationResponse: unknown) => {
        if (locationResponse) {
          const locationsResponse =
            locationResponse as unknown as IStateAllResponse;
          locationsResponse.states = locationsResponse.states.map((data) =>
            data.country.id === CountryCodes.Canada
              ? { ...data, name: `${data.name} (CA)` }
              : data
          );

          subscriber.next(locationsResponse);
        }
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while fetching Locations master data", error);
      }
    );
  });
};

export const getStateNextPage = (
  nextPageURI: string
): Observable<IStateAllResponse> => {
  let url = URLConfig.getBrandsNextPageURl(nextPageURI);

  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (locationResponse: unknown) => {
        if (locationResponse) {
          const locationsResponse =
            locationResponse as unknown as IStateAllResponse;
          locationsResponse.states = locationsResponse.states.map((data) =>
            data.country.id === CountryCodes.Canada
              ? { ...data, name: `${data.name} (CA)` }
              : data
          );

          subscriber.next(locationsResponse);
        }
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while fetching seasons master data", error);
      }
    );
  });
};

export const getStates = (
  queryParams?: Array<{
    key: OdQueryParam;
    value: string[];
  }>
): Observable<IState[]> => {
  let allStates: IState[] = [];

  return new Observable((subscriber) => {
    const errorHandler = (error: any) => {
      subscriber.error(error);
      console.log("Error while fetching States master data", error);
    };

    const responseHandler = (response: IStateAllResponse) => {
      allStates = [...allStates, ...response.states];

      if (response.nextPageUri) {
        getStateNextPage(response.nextPageUri).subscribe({
          next: responseHandler,
          error: errorHandler,
          complete: () => {
            console.info("Completed fetching paginated states");
          },
        });
      } else {
        subscriber.next(allStates);
        subscriber.complete();
      }
    };

    getAllState(queryParams).subscribe({
      next: responseHandler,
      error: errorHandler,
      complete: () => {
        console.info("Completed fetching all States");
      },
    });
  });
};

export const getCounties = (
  queryParams?: Array<{
    key: OdQueryParam;
    value: string[];
  }>
): Observable<ICounty[]> => {
  let allCounties: ICounty[] = [];

  return new Observable((subscriber) => {
    const errorHandler = (error: any) => {
      subscriber.error(error);
      console.log("Error while fetching County master data", error);
    };

    const responseHandler = (response: ICountyAllResponse) => {
      allCounties = [...allCounties, ...(response.counties || [])];

      if (response.nextPageUri) {
        getCountyNextPage(response.nextPageUri).subscribe({
          next: responseHandler,
          error: errorHandler,
          complete: () => {
            console.info("Completed fetching paginated counties");
          },
        });
      } else {
        subscriber.next(allCounties);
        subscriber.complete();
      }
    };

    // Construct the initial URL with query parameters
    getAllCounty(queryParams).subscribe({
      next: responseHandler,
      error: errorHandler,
      complete: () => {
        console.info("Completed fetching all States");
      },
    });
  });
};
